<template>
  <div
    class="table-container"
    :class="{
      'table-container--bordered': props.isBordered,
    }"
  >
    <div class="table-containe-top-slot" v-if="isFilledTopSlot">
      <slot name="topSlot"></slot>
    </div>
    <div class="table-grid">
      <div
        class="table-grid-header"
        :style="{ 'grid-template-columns': widthColumns }"
      >
        <slot name="tableHead">{{ widthColumns }}</slot>
      </div>
      <div class="table-grid-body" @scroll="onScroll">
        <slot name="tableBody"></slot>
      </div>
    </div>
    <div class="table-containe-empty-data-slot" v-if="isFilledEmptyDataSlot">
      <slot name="emptyDataSlot"></slot>
    </div>
    <div class="table-containe-bottom-slot" v-if="isFilledBottomSlot">
      <slot name="bottomSlot"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup generic="T">
import { computed, defineProps, PropType, useSlots } from "vue";

const props = defineProps({
  /**
   * Есть ли граница у общего контейнера
   */
  isBordered: {
    type: Boolean as PropType<Boolean>,
    default: true,
  },
  /**
   * Массив с ширинами колонок
   */
  columns: { type: Array as PropType<string[]>, default: () => [] },
  /**
   * Массив с данными
   */
  data: { type: Array as PropType<Array<T>>, default: () => [] },
  /**
   * * Минимальная ширина
   */
  minWidth: {
    type: String as PropType<string>,
  },
});
// Определение эмиттеров событий компонента
const emits = defineEmits<{
  onScroll: [any]; // Событие при scroll"
}>();

const onScroll = function (event: any) {
  emits("onScroll", event);
};
let widthColumns = computed(() => {
  if (props.columns.length) return props.columns.join(" ");
  return "repeat(auto-fill, minmax(6.25rem, 1fr))";
});

const slots = useSlots();

/**
 * Есть ли слот сверху
 */
const isFilledTopSlot = computed(
  () => slots && slots.topSlot && slots.topSlot()
);
/**
 * Есть ли слот снизу (обычно под пагинацию)
 */
const isFilledBottomSlot = computed(
  () => slots && slots.bottomSlot && slots.bottomSlot()
);
/**
 * Есть ли слот снизу под пустой контент (обычно под компонент SystemMessage)
 */
const isFilledEmptyDataSlot = computed(
  () => slots && slots.emptyDataSlot && slots.emptyDataSlot()
);
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
